module.exports = __webpack_public_path__ + "img/phone.f6fae617.svg";